module.exports = __webpack_public_path__ + "img/03—04—WLAN scanner > Disabled Overlay.3e67ea4b.jpg";